import React from 'react';
import { WEEKS, type ChartGeometry } from '../../utils/chart';
import { palette } from '../../utils/palette';
type ChartAxesProps = {
  geo: ChartGeometry;
  showValues?: boolean;
};
const ticks = [0, -50, -100, -150, -200];
export function ChartAxes({
  geo,
  showValues = true
}: ChartAxesProps) {
  const {
    box,
    x,
    y,
    compact
  } = geo;
  const weeks = compact ? [0, 26, 52] : [0, 13, 26, 39, 52];
  const fs = compact ? 10.5 : 12;
  return <g aria-hidden="true" data-id="element-8" data-mp="1gnrlblqh44ey">
      {ticks.map(t => <g key={t} data-id="element-9" data-mp="1br9i4qaske4q">
          <line x1={box.left} x2={x(WEEKS)} y1={y(t)} y2={y(t)} stroke={palette.hairline} strokeWidth={t === 0 ? 1.5 : 1} strokeDasharray={t === 0 ? undefined : '2 5'} data-id="element-10" data-mp="1bpq1uzp4y32y" />
          {showValues && <text x={box.left - 8} y={y(t)} dy="0.32em" textAnchor="end" fill={palette.faint} fontSize={fs} style={{
        fontVariantNumeric: 'tabular-nums'
      }} data-id="element-11" data-mp="1zh3pwtg97ci4">
              {t === 0 ? '0' : `−${Math.abs(t)}`}
            </text>}
        </g>)}
      {weeks.map(w => <text key={w} x={x(w)} y={box.height - 10} textAnchor={w === 0 ? 'start' : 'middle'} fill={palette.faint} fontSize={fs} data-id="element-12" data-mp="2x26ju5svt4jq">
          {w === 0 ? 'Baseline' : w === WEEKS ? 'Week 52' : `Wk ${w}`}
        </text>)}
      {showValues && <text x={box.left} y={box.top - 14} fill={palette.faint} fontSize={compact ? 10 : 11} data-id="element-13" data-mp="3b1g0t7oww2or">
          ΔFVC from baseline, mL
        </text>}
    </g>;
}